module.exports = __webpack_public_path__ + "img/database.46d77ec.png";